/**
 * Escapa texto que se interpola dentro de HTML.
 *
 * Vive acá y no en `src/pdfs/` porque lo usan dos mundos que no se conocen: la
 * base de los documentos A4 (`src/pdfs/documento.ts`, que lo re-exporta) y el
 * ticket térmico de 80mm (`src/pdfs/generateTicketHTML.ts`). Tener una copia en
 * cada uno era la deuda que el propio CLAUDE.md del repo describe: dos
 * funciones con el mismo nombre que podían divergir sin que nadie lo viera.
 *
 * Todo lo que interpolan esos templates es DATO — títulos de producto,
 * observaciones, nombres de cliente —, nunca markup. Sin escapar, un producto
 * llamado `Faja 5" reforzada` rompe el atributo más cercano y un `<` se come el
 * resto del documento.
 */
export const escapeHtml = (value: unknown): string =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
